const HipervinCole = (coleccion, var_ingles) => {
  let traduccion = "";
  let aplicacion,rutadireccion,rutaimagen,aplicacion2,rutadireccion2,rutaimagen2;
  if (coleccion === "Areageograficas") {
    aplicacion = var_ingles == "es" ? "Espacio y datos" : "Space and data";
    rutadireccion = "/app/mapa/espacioydatos/";
    rutaimagen = "/img/servicios/espaciodatos.png";
    aplicacion2 =
    var_ingles == "es" ? "México en cifras" : "Mexico in figures";
    rutadireccion2 = "/app/areasgeograficas/";
    rutaimagen2 = "/img/servicios/mexencif.png";
  }
  if (coleccion === "Datos_abiertos") {
    aplicacion = var_ingles == "es" ? "Datos abiertos" : "Open data";
    rutadireccion = "/servicios/datosabiertos.html";
    rutaimagen = "/img/servicios/datosabiertos.png";
  }
  if (coleccion === "DENUE") {
    aplicacion = "DENUE";
    rutadireccion = "/app/mapa/denue/";
    rutaimagen = "/img/servicios/denueb.png";
  }
  if (coleccion === "Indicadores" || coleccion === "Indicators") {
    aplicacion = var_ingles == "es" ? "Banco de Indicadores" : "Bank of indicators";
    rutadireccion = "/app/indicadores/";
    rutaimagen = "/img/servicios/biinegi.png";
  }
  if (coleccion === "BieBise") {
    aplicacion = var_ingles == "es" ? "Banco de información económicos (BIE)" : "Economic Information Bank (BIE)";
    rutadireccion = "/app/indicadores/?tm=3";
    rutaimagen = "/img/servicios/biinegi.png";
  }
  if (coleccion === "Bie") {
    aplicacion = var_ingles == "es" ? "Banco de información económicos (BIE)" : "Economic Information Bank (BIE)";
    rutadireccion = "/app/indicadores/?tm=0";
    rutaimagen = "/img/servicios/biinegi.png";
  }
  if (
    coleccion === "Infraestructura" ||
    coleccion === "Infrastructure"
  ) {
    aplicacion =
      var_ingles == "es"
        ? "Infraestructura de la información"
        : "Information infrastructure";
    rutadireccion = "/infraestructura/modelos/";
    rutaimagen = "";
  }
  if (coleccion === "Investigación" || coleccion === "Investigation") {
    aplicacion = var_ingles == "es" ? "Investigación" : "Investigation";
    rutadireccion = "/investigacion/";
    rutaimagen = "";
  }
  if (coleccion === "Mapas" || coleccion === "Maps") {
    aplicacion =
      var_ingles == "es"
        ? "Biblioteca digital de Mapas"
        : "Digital library Maps ";
    rutadireccion = "/app/mapas/";
    rutaimagen = "/img/servicios/mapas.png";
  }
  if (coleccion === "Microdatos" || coleccion === "Microdata") {
    aplicacion = var_ingles == "es" ? "Microdatos" : "Microdata";
    rutadireccion =
      var_ingles == "es" ? "/datos/#Microdatos" : "/datos/#Microdata";
    rutaimagen = "";
  }
  if (coleccion === "Noticias" || coleccion === "News") {
    aplicacion = var_ingles == "es" ? "Sala de prensa" : "Press room";
    rutadireccion = "/app/saladeprensa/";
    rutaimagen = "/img/servicios/prensa.png";
  }
  if (coleccion === "Publicaciones" || coleccion === "Publications") {
    aplicacion =
      var_ingles == "es"
        ? "Biblioteca digital de Publicaciones"
        : "Digital library of Publications ";
    rutadireccion = "/app/publicaciones/";
    rutaimagen = "/img/servicios/Publicaciones.png";
  }
  if (coleccion === "Temas" || coleccion === "Topics") {
    rutadireccion = "/datos/";
    aplicacion = var_ingles == "es" ? "Temas" : "Topics";
    rutaimagen = "";
  }
  if ((coleccion === "Temas") || (coleccion === "Topics")){
    traduccion = (var_ingles == "es") ? "Ver más " + aplicacion : "See more " + aplicacion;
  }
  else{
    traduccion = (var_ingles == "es") ? "Ir a " + aplicacion : "Go to " + aplicacion;
  }

  const root = ReactDOM.createRoot(document.getElementById('rutas'));
  let root2 ="";
  let root3 ="";

  if (coleccion === "Areageograficas") {
    root2 = ReactDOM.createRoot(document.getElementById('separadorId'));
    root3 = ReactDOM.createRoot(document.getElementById('rutas2'));
  }
  let uno= root.render(
      <>
        <a id="rutaaplicacion" href={rutadireccion} style={{ cursor: "pointer", paddingRight: "5px" }} target="_blank">{traduccion}</a>
        <img id="rutaimagen" alt="" src={rutaimagen} width="40" />
      </>
      
  );
  let borrar0= "";
  let borrar= "";
  let borrar2= "";
  if (coleccion === "Areageograficas"){
    let traduccion2 = (var_ingles == "es") ? "Ir a " + aplicacion2 : "Go to " + aplicacion2;
    let dos= root2.render(
      <div id="separador" >|</div>
    );
    let tres= root3.render(
      <>
        <a id="rutaaplicacion" href={rutadireccion2} style={{ cursor: "pointer", paddingRight: "5px" }} target="_blank">{traduccion2}</a>
        <img id="rutaimagen" alt="" src={rutaimagen2} width="40" />
      </>
    );
    return [uno,dos,tres];
  }
  else if((coleccion === "Tabulados")
        ||(coleccion === "Glosario")
        ||(coleccion === "Herramientas")
        ||(coleccion === "Programas")
        ||(coleccion === "Todo")
        )
    {
      borrar0= root.render(
        <></>
      );
    return (borrar0);
  }
  else{
    return (uno);
  }
  // else if((coleccion === "Tabulados")
  //       || (coleccion === "Glosario")
  //       ||(coleccion === "Herramientas")
  //       ||(coleccion === "Programas")
  //       ||(coleccion === "Todo")
  //       ||(coleccion === "All")
  //       ||(coleccion === "Glossary")
  //       ||(coleccion === "Tools")
  //       ||(coleccion === "Programs")
  //       )
  //   {
  //     borrar0= root.render(
  //       <></>
  //     );
  //     borrar= root2.render(
  //       <></>
  //     );
  //     borrar2= root3.render(
  //       <></>
  //     );
  //   return (borrar0,borrar,borrar2);
  // }
  // else{
  // borrar= root2.render(
  //   <></>
  // );
  // borrar2= root3.render(
  //   <></>
  // );
  //   return (borrar,borrar2,uno);
  // }
  
} 
export default HipervinCole;